module.exports = __webpack_public_path__ + "static/img/tmaa12.7bd1d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/tmaa12.png
// module id = hCMk
// module chunks = 0